import { lazyWithPreload } from './utils/lazyWithPreload';

// Route-level code splits. The home dashboard (SessionDashboard) stays in the
// eager entry chunk; everything below is route-triggered. Each export carries
// a .preload() method for opportunistic prefetching from nav entry points.

export const LazyTrackerDashboard = lazyWithPreload(() =>
  import('./components/TrackerDashboard').then((m) => ({ default: m.TrackerDashboard })),
);

export const LazyPatternLibrary = lazyWithPreload(() =>
  import('./components/PatternLibrary').then((m) => ({ default: m.PatternLibrary })),
);

export const LazyAddPatternChooser = lazyWithPreload(() =>
  import('./components/AddPatternChooser').then((m) => ({ default: m.AddPatternChooser })),
);

export const LazyPatternBuilder = lazyWithPreload(() =>
  import('./components/PatternBuilder').then((m) => ({ default: m.PatternBuilder })),
);

export const LazySimplePatternWizard = lazyWithPreload(() =>
  import('./components/SimplePatternWizard').then((m) => ({ default: m.SimplePatternWizard })),
);

export const LazySettings = lazyWithPreload(() =>
  import('./components/Settings').then((m) => ({ default: m.Settings })),
);

export const LazyAboutPage = lazyWithPreload(() =>
  import('./components/AboutPage').then((m) => ({ default: m.AboutPage })),
);

export const LazyJustKnitWizard = lazyWithPreload(() =>
  import('./components/JustKnitWizard').then((m) => ({ default: m.JustKnitWizard })),
);

export const LazyAllProjectsPage = lazyWithPreload(() =>
  import('./components/AllProjectsPage').then((m) => ({ default: m.AllProjectsPage })),
);

export const LazySyncDetailsPage = lazyWithPreload(() =>
  import('./components/SyncDetailsPage').then((m) => ({ default: m.SyncDetailsPage })),
);

export const LazyActivityCalendar = lazyWithPreload(() =>
  import('./components/ActivityCalendar/ActivityCalendar').then((m) => ({
    default: m.ActivityCalendar,
  })),
);

// Keep this lazy. The wizard `?raw`-imports skills/knit-dsl-authoring/PROMPT.md
// (~28 KB) and the retry-iteration template, both inlined into this chunk.
// Hoisting it into the eager entry would balloon the home bundle.
export const LazyAiImportWizard = lazyWithPreload(() =>
  import('./components/AiImportWizard').then((m) => ({ default: m.AiImportWizard })),
);
